// extracted by mini-css-extract-plugin
export default {"root":"lbGSQBHnSg","root_small":"K8XRbcxxcX","text":"de66GiNA1U","icon":"lK1HqQti1q"};